import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const RadioMinusIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>RadioMinusIcon</title>
    <path d="M24,4 C29.3043298,4 34.3914081,6.10713681 38.1421356,9.85786438 C41.8928632,13.6085919 44,18.6956702 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M24,8 C15.163444,8 8,15.163444 8,24 C8,32.836556 15.163444,40 24,40 C28.2434638,40 32.3131264,38.3142906 35.3137085,35.3137085 C38.3142906,32.3131264 40,28.2434638 40,24 C40,15.163444 32.836556,8 24,8 Z M33,21 L33,27 L15,27 L15,21 L33,21 Z" />
  </IconBase>
);
